import { configureStore } from "@reduxjs/toolkit";
import navbarSlice from "../Auth/navbarSlice";
import profile360Slice from "../Component/Profile360/js/slice";
export const store = configureStore({
  reducer: {
    fetchNavbar: navbarSlice,
    ManageProfile360: profile360Slice,
  },
});
